module.exports = __webpack_public_path__ + "img/buy-icon4.f3c1ae2.png";